module.exports = __webpack_public_path__ + "static/media/down-arrow.31492584.svg";